var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarRank2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9C18 4.0186 13.9814 0 9 0C4.0186 0 0 4.0186 0 9C0 13.9814 4.0186 18 9 18C13.9814 18 18 13.9814 18 9ZM13.8977 8.12093L12.0558 9.79535C11.9302 9.87907 11.8884 10.0465 11.9302 10.214L12.4326 12.6837C12.5581 13.2698 11.9302 13.7302 11.386 13.4372L9.2093 12.1814C9.08372 12.0977 8.91628 12.0977 8.7907 12.1814L6.61395 13.4372C6.06977 13.7302 5.44186 13.2698 5.56744 12.6837L6.06977 10.214C6.11163 10.0884 6.06977 9.92093 5.94419 9.83721L4.10233 8.16279C3.64186 7.74419 3.89302 7.03256 4.47907 6.94884L6.9907 6.65581C7.15814 6.65581 7.28372 6.53023 7.32558 6.40465L8.37209 4.10233C8.62326 3.55814 9.4186 3.55814 9.66977 4.10233L10.7163 6.40465C10.7581 6.53023 10.9256 6.61395 11.0512 6.65581L13.5628 6.94884C14.107 6.9907 14.3581 7.70233 13.8977 8.12093Z",
    fill: "#BFBFBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRank2);
export default __webpack_public_path__ + "static/media/StarRank2.33f78ef7b4e59a77b2659bfb2e066e6c.svg";
export { ForwardRef as ReactComponent };